import {useEffect, useState} from "react";

export const useChangeActiveCustomerModalHook = (searchParams, activeCustomerID) => {
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, productID: null, redirectPath: '', open: false, product: '', customerID: null });

    useEffect(() => {
        const activeCustomerIDParam = searchParams?.ActiveCustomerID;
        const activeCustomerNameParam = searchParams?.ActiveCustomerName;
        if (activeCustomerIDParam && activeCustomerNameParam && activeCustomerIDParam!==activeCustomerID) {
            setRedirectOptions((previousState) => { return {...previousState, open: true, customerID: activeCustomerIDParam, product: activeCustomerNameParam}})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [redirectOptions, setRedirectOptions];
}